(() => {
  const qs = (sel, root = document) => root.querySelector(sel);
  const qsa = (sel, root = document) => [...root.querySelectorAll(sel)];
  const eventElement = (event, selector) => event.composedPath().find((node) => node instanceof Element && node.matches(selector));
  const menuButton = qs('[data-menu-toggle]');
  const nav = qs('[data-site-nav]');
  if (menuButton && nav) {
    menuButton.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      menuButton.setAttribute('aria-expanded', String(open));
      if (open) nav.querySelector('a')?.focus();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && nav.classList.contains('is-open')) {
        nav.classList.remove('is-open');
        menuButton.setAttribute('aria-expanded', 'false');
        menuButton.focus();
      }
    });
  }
  const shirtViewLabels = {
    front: "Front view of The In Between Tee in white, black, and light charcoal gray, with the signature embroidered on the wearer's front-left chest",
    back: 'Back view of The In Between Tee in white, black, and light charcoal gray, with the main artwork and signature embroidered into the lower-left back hem'
  };
  const upcomingViewLabels = {
    front: "Front view of the Can't Call No More 76 Summers Tee in white, black, and dark gray, with the JT Wear & Co. signature on the wearer's front-left chest",
    back: "Back view of the Can't Call No More 76 Summers Tee in white, black, and dark gray, with the statement artwork and JT Wear & Co. origin signature at the lower-left back hem"
  };
  document.addEventListener('click', (event) => {
    const shirtButton = eventElement(event, '[data-shirt-view]');
    if (shirtButton) {
      const viewer = shirtButton.closest('[data-shirt-viewer]');
      const view = shirtButton.dataset.shirtView;
      const canvas = viewer ? qs('[data-shirt-canvas]', viewer) : null;
      if (viewer && shirtViewLabels[view]) {
        viewer.dataset.view = view;
        qsa('[data-shirt-view]', viewer).forEach((option) => option.setAttribute('aria-pressed', String(option === shirtButton)));
        if (canvas) canvas.setAttribute('aria-label', `${shirtViewLabels[view]}. Open enlarged image.`);
      }
    }
    const upcomingButton = eventElement(event, '[data-upcoming-view]');
    if (upcomingButton) {
      const viewer = upcomingButton.closest('[data-upcoming-viewer]');
      const view = upcomingButton.dataset.upcomingView;
      const image = viewer ? qs('[data-upcoming-image]', viewer) : null;
      const viewLabels = viewer ? {
        front: viewer.dataset.frontLabel || upcomingViewLabels.front,
        back: viewer.dataset.backLabel || upcomingViewLabels.back
      } : upcomingViewLabels;
      if (viewer && viewLabels[view]) {
        viewer.dataset.view = view;
        if (image) {
          image.src = view === 'front' ? image.dataset.frontSrc : image.dataset.backSrc;
          image.alt = viewLabels[view];
        }
        qsa('[data-upcoming-view]', viewer).forEach((option) => option.setAttribute('aria-pressed', String(option === upcomingButton)));
      }
    }
  });
  const imageLightbox = qs('[data-image-lightbox]');
  const imageLightboxImage = imageLightbox ? qs('[data-image-lightbox-image]', imageLightbox) : null;
  const imageLightboxCaption = imageLightbox ? qs('[data-image-lightbox-caption]', imageLightbox) : null;
  const closeImageLightbox = () => {
    if (!imageLightbox) return;
    if (typeof imageLightbox.close === 'function') imageLightbox.close();
    else imageLightbox.removeAttribute('open');
  };
  const openImageLightbox = (trigger) => {
    if (!imageLightbox || !imageLightboxImage) return;
    const viewer = trigger.closest('[data-product-viewer], [data-shirt-viewer], [data-upcoming-viewer]');
    const view = viewer?.dataset.view === 'front' ? 'front' : 'back';
    const inlineImage = trigger.matches('img') ? trigger : qs('img', trigger);
    const viewSource = view === 'front' ? trigger.dataset.frontSrc : trigger.dataset.backSrc;
    const source = trigger.dataset.zoomSrc || viewSource || inlineImage?.currentSrc || inlineImage?.src || '';
    if (!source) return;
    const label = (inlineImage?.alt || trigger.getAttribute('aria-label') || 'Expanded product image')
      .replace(/\.?\s*Open enlarged image\.?$/i, '');
    imageLightboxImage.src = source;
    imageLightboxImage.alt = label;
    if (imageLightboxCaption) imageLightboxCaption.textContent = label;
    if (typeof imageLightbox.showModal === 'function') imageLightbox.showModal();
    else imageLightbox.setAttribute('open', '');
    qs('[data-image-lightbox-close]', imageLightbox)?.focus();
  };
  document.addEventListener('click', (event) => {
    const trigger = eventElement(event, '[data-image-zoom]');
    if (trigger) openImageLightbox(trigger);
  });
  qs('[data-image-lightbox-close]', imageLightbox)?.addEventListener('click', closeImageLightbox);
  imageLightbox?.addEventListener('click', (event) => {
    if (event.target === imageLightbox) closeImageLightbox();
  });
  qsa('[data-quantity]').forEach((wrap) => {
    const input = qs('input', wrap);
    const normalizeQuantity = () => {
      const min = Number(input.min || 1);
      const max = Number(input.max || 10);
      const value = Number.parseInt(input.value, 10);
      input.value = String(Math.min(max, Math.max(min, Number.isFinite(value) ? value : min)));
    };
    const clampEnteredQuantity = () => {
      if (input.value === '') return;
      const min = Number(input.min || 1);
      const max = Number(input.max || 10);
      const value = Number.parseInt(input.value, 10);
      if (Number.isFinite(value)) input.value = String(Math.min(max, Math.max(min, value)));
    };
    qs('[data-qty-minus]', wrap)?.addEventListener('click', () => {
      input.value = Math.max(Number(input.min || 1), Number(input.value || 1) - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    qs('[data-qty-plus]', wrap)?.addEventListener('click', () => {
      input.value = Math.min(Number(input.max || 10), Number(input.value || 1) + 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    input.addEventListener('input', clampEnteredQuantity);
    input.addEventListener('change', normalizeQuantity);
    input.addEventListener('blur', normalizeQuantity);
  });
  qsa('[data-variant-picker]').forEach((picker) => {
    const section = picker.closest('.featured-drop, .product-page') || document;
    const colorInputs = qsa('input[data-option-name="color"], input[name="Color"], input[name="Colour"]', picker);
    const updateColor = (input) => {
      qsa('.color-choice', picker).forEach((label) => label.classList.toggle('is-selected', label.contains(input)));
      qsa('[data-color-key]', section).forEach((key) => key.classList.toggle('is-selected', key.dataset.colorKey === input.value));
    };
    const form = picker.closest('form[data-product-form]');
    const variantInput = form ? qs('[data-variant-id]', form) : null;
    const addButton = form ? qs('[data-add-to-cart]', form) : null;
    const addLabel = addButton ? qs('[data-add-to-cart-label]', addButton) : null;
    const status = qs('[data-variant-status]', picker);
    let variants = [];
    try {
      variants = picker.dataset.productVariants ? JSON.parse(picker.dataset.productVariants) : [];
    } catch (error) {
      variants = [];
    }
    const updateVariant = () => {
      qsa('input[type="radio"]', picker).forEach((input) => {
        const label = input.closest('label');
        if (label) label.classList.toggle('is-selected', input.checked);
      });
      const selectedOptions = qsa('input[data-option-position]:checked', picker)
        .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
        .map((input) => input.value);
      const variant = variants.find((item) => item.options.every((option, index) => option === selectedOptions[index]));
      if (!variant || !variantInput) return;
      variantInput.value = variant.id;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      if (addButton) addButton.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? addButton.dataset.availableLabel : 'Sold Out';
      if (status) status.textContent = variant.available ? '' : 'This color and size is currently unavailable.';
    };
    qsa('input[type="radio"]', picker).forEach((input) => input.addEventListener('change', () => {
      if (input.dataset.optionName === 'color' || /colou?r/i.test(input.name)) updateColor(input);
      updateVariant();
    }));
    const selected = colorInputs.find((input) => input.checked) || colorInputs[0];
    if (selected) updateColor(selected);
    updateVariant();
  });
  const dialog = qs('[data-interest-dialog]');
  qsa('[data-open-interest]').forEach((button) => {
    button.addEventListener('click', () => {
      if (!dialog) return;
      const type = button.dataset.type || 'drop_notification';
      qs('[data-interest-type]', dialog).value = type;
      const form = qs('form', dialog);
      if (form) form.dataset.endpoint = type === 'drop_notification' ? (dialog.dataset.notifyEndpoint || '') : (dialog.dataset.preorderEndpoint || '');
      qs('[data-interest-title]', dialog).textContent = 'Future Drop Updates';
      qs('[data-interest-copy]', dialog).textContent = 'Leave your email and we will send future release updates.';
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      qs('input[type="email"]', dialog)?.focus();
    });
  });
  qsa('[data-close-dialog]').forEach((button) => button.addEventListener('click', () => button.closest('dialog')?.close()));
  qsa('form[data-ajax-form], [data-interest-dialog] form').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const status = qs('.form-status', form);
      const email = qs('input[type="email"]', form);
      status?.classList.remove('error');
      if (!email?.validity.valid) {
        if (status) {
          status.textContent = 'Enter a valid email address.';
          status.classList.add('error');
        }
        email?.focus();
        return;
      }
      const consent = qs('input[name="consent"]', form);
      if (consent && !consent.checked) {
        if (status) {
          status.textContent = 'Consent is required before submitting.';
          status.classList.add('error');
        }
        consent.focus();
        return;
      }
      if (status) status.textContent = 'Submitting...';
      const endpoint = form.dataset.endpoint || '';
      if (!endpoint) {
        if (status) status.textContent = 'Saved locally for preview. Configure a secure endpoint before launch.';
        form.reset();
        return;
      }
      try {
        const response = await fetch(endpoint, { method: 'POST', body: new FormData(form), credentials: 'same-origin' });
        if (response.status === 409) throw new Error('duplicate');
        if (response.status === 429) throw new Error('rate');
        if (!response.ok) throw new Error('server');
        if (status) status.textContent = 'You are on the list.';
        form.reset();
      } catch (error) {
        if (status) {
          status.classList.add('error');
          status.textContent = error.message === 'duplicate' ? 'This email is already on the list.' : error.message === 'rate' ? 'Too many tries. Please wait and try again.' : 'Something went wrong. Please try again.';
        }
      }
    });
  });

  const memorialDatabase = {
    open() {
      return new Promise((resolve, reject) => {
        if (!('indexedDB' in window)) return reject(new Error('storage'));
        const request = indexedDB.open('jtMemorialArchive', 1);
        request.onupgradeneeded = () => {
          const database = request.result;
          if (!database.objectStoreNames.contains('submissions')) database.createObjectStore('submissions', { keyPath: 'id' });
        };
        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error || new Error('storage'));
      });
    },
    async all() {
      const database = await this.open();
      return new Promise((resolve, reject) => {
        const request = database.transaction('submissions', 'readonly').objectStore('submissions').getAll();
        request.onsuccess = () => resolve(request.result || []);
        request.onerror = () => reject(request.error || new Error('storage'));
      }).finally(() => database.close());
    },
    async put(value) {
      const database = await this.open();
      return new Promise((resolve, reject) => {
        const request = database.transaction('submissions', 'readwrite').objectStore('submissions').put(value);
        request.onsuccess = () => resolve(value);
        request.onerror = () => reject(request.error || new Error('storage'));
      }).finally(() => database.close());
    },
    async delete(id) {
      const database = await this.open();
      return new Promise((resolve, reject) => {
        const request = database.transaction('submissions', 'readwrite').objectStore('submissions').delete(id);
        request.onsuccess = () => resolve();
        request.onerror = () => reject(request.error || new Error('storage'));
      }).finally(() => database.close());
    }
  };

  const memorialCategoryLabel = (value = 'other') => ({
    tattoos: 'Tattoos', artwork: 'Artwork', paintings: 'Paintings', drawings: 'Drawings', helmets: 'Helmets',
    motorcycle_art: 'Motorcycle Artwork', stickers: 'Stickers', murals: 'Murals', clothing: 'Clothing', other: 'Other Memorial Pieces'
  })[value] || value.replaceAll('_', ' ').replace(/\b\w/g, (letter) => letter.toUpperCase());
  const memorialBoolean = (value) => value === true || value === 'true' || value === 1;
  const memorialLocation = (item) => [item.city, item.state].filter(Boolean).join(', ');
  const memorialPublicName = (item) => memorialBoolean(item.anonymous) || !item.submitter_name ? 'Anonymous' : item.submitter_name;
  const memorialSafeImageUrl = (value) => {
    if (!value) return '';
    if (value instanceof Blob) return URL.createObjectURL(value);
    try {
      const url = new URL(value, window.location.href);
      return ['http:', 'https:', 'blob:', 'data:'].includes(url.protocol) ? url.href : '';
    } catch (error) {
      return '';
    }
  };
  const memorialElement = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined && text !== null) element.textContent = text;
    return element;
  };
  const memorialAddDetailLine = (root, label, value) => {
    if (!value) return;
    const line = memorialElement('p');
    const strong = memorialElement('strong', '', `${label}: `);
    line.append(strong, document.createTextNode(value));
    root.append(line);
  };
  const memorialBuildCard = (item) => {
    const imageUrl = memorialSafeImageUrl(item.image_url || item.photo);
    if (!imageUrl) return null;
    const category = String(item.category || 'other').toLowerCase().replace(/[^a-z0-9_]+/g, '_').replace(/^_+|_+$/g, '') || 'other';
    const categoryLabel = memorialCategoryLabel(category);
    const title = item.title || categoryLabel;
    const card = memorialElement('article', `memorial-card${memorialBoolean(item.featured) ? ' is-featured' : ''}`);
    card.dataset.memorialCard = '';
    card.dataset.category = category;
    card.dataset.dynamicMemorial = '';
    const open = memorialElement('button', 'memorial-card-open');
    open.type = 'button';
    open.dataset.memorialOpen = '';
    open.setAttribute('aria-label', `Open ${title}`);
    open._memorialItem = { ...item, image_url: imageUrl };
    const image = memorialElement('img');
    image.src = imageUrl;
    image.alt = title;
    image.loading = 'lazy';
    open.append(image, memorialElement('span', 'memorial-card-category', categoryLabel));
    const copy = memorialElement('div', 'memorial-card-copy');
    if (item.title) copy.append(memorialElement('h3', '', item.title));
    const byline = memorialElement('p', 'memorial-byline', memorialPublicName(item));
    if (item.artist_name) byline.append(memorialElement('span', '', `Created by ${item.artist_name}`));
    copy.append(byline);
    const location = memorialLocation(item);
    if (location) copy.append(memorialElement('p', 'memorial-location', location));
    if (item.story) {
      const preview = item.story.split(/\s+/).slice(0, 24).join(' ');
      copy.append(memorialElement('p', 'memorial-story-preview', `${preview}${item.story.split(/\s+/).length > 24 ? '...' : ''}`));
    }
    card.append(open, copy);
    return card;
  };
  const memorialFillDialog = (dialog, item) => {
    const content = qs('[data-memorial-dialog-content]', dialog);
    if (!content) return;
    content.replaceChildren();
    const media = memorialElement('div', 'memorial-detail-media');
    const image = memorialElement('img');
    image.src = item.image_url;
    image.alt = item.title || memorialCategoryLabel(item.category);
    media.append(image);
    const copy = memorialElement('div', 'memorial-detail-copy');
    copy.append(memorialElement('p', 'eyebrow', `${memorialCategoryLabel(item.category)}${memorialBoolean(item.featured) ? ' / Featured' : ''}`));
    copy.append(memorialElement('h2', '', item.title || memorialCategoryLabel(item.category)));
    copy.append(memorialElement('p', 'memorial-byline', `Shared by ${memorialPublicName(item)}`));
    memorialAddDetailLine(copy, 'Artist / creator', item.artist_name);
    memorialAddDetailLine(copy, 'Shop', item.shop_name);
    memorialAddDetailLine(copy, 'Location', memorialLocation(item));
    if (memorialBoolean(item.show_social)) memorialAddDetailLine(copy, 'Social', item.social_handle);
    memorialAddDetailLine(copy, 'Connection to Jake', item.connection);
    if (item.story) copy.append(memorialElement('div', 'memorial-full-story', item.story));
    content.append(media, copy);
  };

  qsa('[data-memorial-gallery]').forEach(async (gallery) => {
    const dialog = qs('[data-memorial-dialog]', gallery);
    const grid = qs('[data-memorial-grid]', gallery);
    const featured = qs('[data-memorial-featured]', gallery);
    const empty = qs('[data-memorial-empty]', gallery);
    const filters = qs('[data-memorial-filters]', gallery);
    const applyFilter = (category) => {
      qsa('[data-gallery-filter]', filters).forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.galleryFilter === category)));
      qsa('[data-memorial-card]', grid).forEach((card) => { card.hidden = category !== 'all' && card.dataset.category !== category; });
    };
    const refreshFilters = () => {
      const categories = new Set(['tattoos', 'artwork']);
      qsa('[data-memorial-card]', grid).forEach((card) => categories.add(card.dataset.category));
      [...categories].forEach((category) => {
        if (qs(`[data-gallery-filter="${category}"]`, filters)) return;
        const button = memorialElement('button', '', memorialCategoryLabel(category));
        button.type = 'button';
        button.dataset.galleryFilter = category;
        button.setAttribute('aria-pressed', 'false');
        filters.append(button);
      });
      if (empty) empty.hidden = qsa('[data-memorial-card]', grid).length > 0;
    };
    filters?.addEventListener('click', (event) => {
      const button = event.target.closest('[data-gallery-filter]');
      if (button) applyFilter(button.dataset.galleryFilter);
    });
    gallery.addEventListener('click', (event) => {
      const open = event.target.closest('[data-memorial-open]');
      if (!open || !dialog) return;
      const template = qs('[data-memorial-detail]', open.closest('[data-memorial-card]'));
      const content = qs('[data-memorial-dialog-content]', dialog);
      if (template && content) content.replaceChildren(template.content.cloneNode(true));
      else if (open._memorialItem) memorialFillDialog(dialog, open._memorialItem);
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      qs('[data-close-memorial-dialog]', dialog)?.focus();
    });
    qs('[data-close-memorial-dialog]', dialog)?.addEventListener('click', () => dialog.close());
    dialog?.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
    const addApprovedItems = (items) => {
      items.filter((item) => item.status === 'approved').sort((a, b) => new Date(b.approved_at || b.updated_at || b.created_at) - new Date(a.approved_at || a.updated_at || a.created_at)).forEach((item) => {
        const card = memorialBuildCard(item);
        if (card) (memorialBoolean(item.featured) ? featured : grid)?.append(card);
      });
      refreshFilters();
    };
    const endpoint = gallery.dataset.galleryEndpoint;
    if (endpoint) {
      try {
        const response = await fetch(endpoint, { headers: { Accept: 'application/json' }, credentials: 'omit' });
        if (!response.ok) throw new Error('gallery');
        const payload = await response.json();
        addApprovedItems(Array.isArray(payload) ? payload : payload.items || []);
      } catch (error) {
        gallery.dataset.galleryError = 'true';
        refreshFilters();
      }
    } else if (/^(localhost|127\.0\.0\.1)$/.test(window.location.hostname)) {
      try { addApprovedItems(await memorialDatabase.all()); } catch (error) { refreshFilters(); }
    } else refreshFilters();
  });

  qsa('[data-memorial-form]').forEach((form) => {
    const input = qs('[data-memorial-file]', form);
    const preview = qs('[data-memorial-preview]', form);
    const previewImage = qs('img', preview);
    const status = qs('.form-status', form);
    let previewUrl = '';
    const clearPreview = () => {
      if (previewUrl) URL.revokeObjectURL(previewUrl);
      previewUrl = '';
      if (previewImage) previewImage.removeAttribute('src');
      if (preview) preview.hidden = true;
    };
    const validateImage = (file) => {
      if (!file) return 'Choose a photo to submit.';
      if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) return 'Use a JPG, JPEG, PNG, or WEBP image.';
      if (file.size > 8 * 1024 * 1024) return 'The image must be 8 MB or smaller.';
      return '';
    };
    input?.addEventListener('change', () => {
      clearPreview();
      const file = input.files?.[0];
      const error = validateImage(file);
      input.setCustomValidity(error);
      if (error) {
        if (status) { status.textContent = error; status.classList.add('error'); }
        return;
      }
      if (status) { status.textContent = ''; status.classList.remove('error'); }
      previewUrl = URL.createObjectURL(file);
      if (previewImage) previewImage.src = previewUrl;
      if (preview) preview.hidden = false;
    });
    qs('[data-remove-memorial-image]', form)?.addEventListener('click', () => {
      clearPreview();
      input.value = '';
      input.focus();
    });
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      status?.classList.remove('error');
      const file = input?.files?.[0];
      const imageError = validateImage(file);
      input?.setCustomValidity(imageError);
      if (!form.checkValidity()) {
        if (status) { status.textContent = imageError || 'Complete the required fields before submitting.'; status.classList.add('error'); }
        form.reportValidity();
        return;
      }
      if (form.elements.website?.value) return;
      if (status) status.textContent = 'Submitting for review...';
      const endpoint = form.dataset.endpoint;
      try {
        if (endpoint) {
          const target = new URL(endpoint, window.location.href);
          const response = await fetch(target, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' }, credentials: target.origin === window.location.origin ? 'same-origin' : 'omit' });
          if (response.status === 413) throw new Error('size');
          if (response.status === 429) throw new Error('rate');
          if (!response.ok) throw new Error('server');
        } else if (/^(localhost|127\.0\.0\.1)$/.test(window.location.hostname)) {
          const data = new FormData(form);
          const now = new Date().toISOString();
          await memorialDatabase.put({
            id: crypto.randomUUID ? crypto.randomUUID() : `jt-${Date.now()}`,
            category: data.get('category'), title: data.get('title'), photo: file,
            submitter_name: data.get('submitter_name'), anonymous: data.has('anonymous'),
            social_handle: data.get('social_handle'), show_social: data.has('show_social'),
            artist_name: data.get('artist_name'), shop_name: data.get('shop_name'), city: data.get('city'), state: data.get('state'),
            story: data.get('story'), connection: data.get('connection'), permission_granted: true,
            status: 'pending', featured: false, created_at: now, updated_at: now, approved_at: null
          });
        } else throw new Error('unavailable');
        form.reset();
        clearPreview();
        if (status) status.textContent = "Thank you for sharing a piece of JT's story. Your submission has been received and will be reviewed before appearing in the JT Memorial Art gallery.";
      } catch (error) {
        if (status) {
          status.classList.add('error');
          status.textContent = error.message === 'size' ? 'The uploaded image is too large.' : error.message === 'rate' ? 'Too many submissions. Please wait and try again.' : error.message === 'unavailable' ? 'Submissions are temporarily unavailable while secure review is being configured.' : 'Your submission could not be sent. Please try again.';
        }
      }
    });
  });

  const memorialAdmin = qs('[data-memorial-admin]');
  if (memorialAdmin) {
    const list = qs('[data-memorial-admin-list]', memorialAdmin);
    const empty = qs('[data-memorial-admin-empty]', memorialAdmin);
    const status = qs('[data-memorial-admin-status]', memorialAdmin);
    const adminField = (labelText, name, value = '', type = 'text') => {
      const label = memorialElement('label', 'memorial-admin-field', labelText);
      const input = type === 'textarea' ? memorialElement('textarea') : memorialElement('input');
      input.name = name;
      if (type !== 'textarea') input.type = type;
      input.value = value || '';
      label.append(input);
      return label;
    };
    const renderAdmin = async () => {
      const items = (await memorialDatabase.all()).sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      list.replaceChildren();
      empty.hidden = items.length > 0;
      items.forEach((item) => {
        const card = memorialElement('article', 'memorial-admin-card');
        card.dataset.id = item.id;
        const image = memorialElement('img');
        image.src = memorialSafeImageUrl(item.photo || item.image_url);
        image.alt = item.title || 'Memorial submission preview';
        const form = memorialElement('form', 'memorial-admin-edit');
        form.dataset.memorialAdminEdit = '';
        form.append(memorialElement('p', 'eyebrow', `${item.status} / ${new Date(item.created_at).toLocaleString()}`));
        const row = memorialElement('div', 'memorial-admin-row');
        const categoryLabel = memorialElement('label', 'memorial-admin-field', 'Category');
        const category = memorialElement('select');
        category.name = 'category';
        ['tattoos', 'artwork', 'paintings', 'drawings', 'helmets', 'motorcycle_art', 'stickers', 'murals', 'clothing', 'other'].forEach((value) => {
          const option = memorialElement('option', '', memorialCategoryLabel(value));
          option.value = value;
          option.selected = value === item.category;
          category.append(option);
        });
        categoryLabel.append(category);
        const stateLabel = memorialElement('label', 'memorial-admin-field', 'Status');
        const state = memorialElement('select');
        state.name = 'status';
        ['pending', 'approved', 'rejected'].forEach((value) => {
          const option = memorialElement('option', '', value[0].toUpperCase() + value.slice(1));
          option.value = value;
          option.selected = value === item.status;
          state.append(option);
        });
        stateLabel.append(state);
        row.append(categoryLabel, stateLabel);
        form.append(row, adminField('Title', 'title', item.title), adminField('Name', 'submitter_name', item.submitter_name), adminField('Social handle', 'social_handle', item.social_handle), adminField('Artist / creator', 'artist_name', item.artist_name), adminField('Shop', 'shop_name', item.shop_name), adminField('City', 'city', item.city), adminField('State', 'state', item.state), adminField('Story', 'story', item.story, 'textarea'), adminField('Connection to Jake', 'connection', item.connection, 'textarea'));
        [['anonymous', 'Display anonymously', item.anonymous], ['show_social', 'Show social handle publicly', item.show_social], ['featured', 'Feature this piece', item.featured]].forEach(([name, text, checked]) => {
          const label = memorialElement('label', 'check', text);
          const input = memorialElement('input');
          input.type = 'checkbox';
          input.name = name;
          input.checked = memorialBoolean(checked);
          label.prepend(input);
          form.append(label);
        });
        const actions = memorialElement('div', 'memorial-admin-actions');
        [['save', 'Save Changes'], ['approve', 'Approve'], ['reject', 'Reject'], ['delete', 'Delete']].forEach(([action, text]) => {
          const button = memorialElement('button', action === 'approve' ? 'button light' : 'button', text);
          button.type = action === 'save' ? 'submit' : 'button';
          button.dataset.adminAction = action;
          actions.append(button);
        });
        form.append(actions);
        card.append(image, form);
        list.append(card);
      });
    };
    list.addEventListener('submit', async (event) => {
      event.preventDefault();
      const form = event.target.closest('[data-memorial-admin-edit]');
      const card = form?.closest('[data-id]');
      if (!form || !card) return;
      const item = (await memorialDatabase.all()).find((entry) => entry.id === card.dataset.id);
      if (!item) return;
      const data = new FormData(form);
      ['category', 'status', 'title', 'submitter_name', 'social_handle', 'artist_name', 'shop_name', 'city', 'state', 'story', 'connection'].forEach((field) => { item[field] = data.get(field) || ''; });
      item.anonymous = data.has('anonymous'); item.show_social = data.has('show_social'); item.featured = data.has('featured'); item.updated_at = new Date().toISOString();
      if (item.status === 'approved' && !item.approved_at) item.approved_at = item.updated_at;
      await memorialDatabase.put(item);
      if (status) status.textContent = 'Submission changes saved.';
      await renderAdmin();
    });
    list.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-admin-action]');
      if (!button || button.dataset.adminAction === 'save') return;
      const card = button.closest('[data-id]');
      const item = (await memorialDatabase.all()).find((entry) => entry.id === card?.dataset.id);
      if (!item) return;
      if (button.dataset.adminAction === 'delete') {
        if (!window.confirm('Delete this local memorial submission?')) return;
        await memorialDatabase.delete(item.id);
        if (status) status.textContent = 'Submission deleted.';
      } else {
        item.status = button.dataset.adminAction === 'approve' ? 'approved' : 'rejected';
        item.updated_at = new Date().toISOString();
        if (item.status === 'approved') item.approved_at = item.updated_at;
        await memorialDatabase.put(item);
        if (status) status.textContent = `Submission marked ${item.status}.`;
      }
      await renderAdmin();
    });
    renderAdmin().catch(() => { if (status) status.textContent = 'The local moderation queue could not be opened.'; });
  }
})();
